import _ from "lodash";

export default class wizardsController {
  static markWizardAsHidden(userId, name) {
    const wizardsString = localStorage.getItem("hiddenWizards" + userId);
    let wizards = [];

    if (wizardsString) {
      wizards = JSON.parse(wizardsString);
    }

    const wizard = _.find(wizards, x => x == name);
    if (!wizard) {
      wizards.push(name);
      localStorage.setItem("hiddenWizards" + userId, JSON.stringify(wizards));
    }
  }

  static checIskWizardHidden(userId, name) {
    const wizardsString = localStorage.getItem("hiddenWizards" + userId);
    if (wizardsString) {
      const wizards = JSON.parse(wizardsString);
      return _.find(wizards, x => x == name);
    }

    return false;
  }
}
